import { render } from "./ProcedureCategories.vue?vue&type=template&id=5634069e&scoped=true"
import script from "./ProcedureCategories.vue?vue&type=script&lang=js"
export * from "./ProcedureCategories.vue?vue&type=script&lang=js"

import "./ProcedureCategories.vue?vue&type=style&index=0&id=5634069e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5634069e"]])

export default __exports__